import React from 'react';
import { Shield, MessageSquare, Clock, Users } from 'lucide-react';

interface WelcomeScreenProps {
  onNext: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onNext }) => {
  return (
    <div className="animate-fadeIn">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold mb-3">
          Get Expert Home Service Quotes
        </h1>
        <p className="text-gray-600">
          Tell us about your project once, and we'll handle everything else.
        </p>
      </div>

      <div className="space-y-6 mb-8">
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5 text-gray-700" />
          <p className="text-gray-700">Your contact information stays private and protected</p>
        </div>
        
        <div className="flex items-center gap-3">
          <MessageSquare className="w-5 h-5 text-gray-700" />
          <p className="text-gray-700">We communicate with contractors on your behalf</p>
        </div>
        
        <div className="flex items-center gap-3">
          <Users className="w-5 h-5 text-gray-700" />
          <p className="text-gray-700">Get quotes from multiple pre-screened professionals</p>
        </div>
        
        <div className="flex items-center gap-3">
          <Clock className="w-5 h-5 text-gray-700" />
          <p className="text-gray-700">Receive competitive quotes within 24 hours</p>
        </div>
      </div>

      <button
        onClick={onNext}
        className="w-full bg-black text-white px-4 py-3 rounded-lg font-medium transition-colors duration-300 hover:bg-gray-900"
      >
        Get Started
      </button>
    </div>
  );
};

export default WelcomeScreen;